<template>
  <woot-modal show :on-close="onClose">
    <woot-modal-header
      header-title="Essa mensagem ficará oculta"
      header-content="Solicite que um administrador da conta desoculte a mensagem para que você possa ver o contexto."
    />
    <div
      class="modal-footer delete-item"
    >
      <button
        class="button secondary"
        @click="$emit('close')"
      >
        Fechar
      </button>
      <button
        class="button"
        @click="onSubmit"
      >
        Confirmar
      </button>
    </div>
  </woot-modal>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    message: {
      type: Object,
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onSubmit(event) {
      this.$store.dispatch('hideMessage', {
        conversationId: this.message.conversation_id,
        messageId: this.message.id
      });

      this.showAlert('Ocultando mensagem...');
      this.onClose();
    },
  },
};
</script>

<style lang="scss">
.modal-mask .modal--close {
  z-index: 1;
}
.hide_message {
  background: #fff;
  padding: 10px;
  position: relative;
  height: 100%;
  min-width: 430px;
  &__title {
    text-align: left;
    &-primary {
      font-size: 1.5rem;
    }
  }
}
</style>